import { h } from "preact";
import { useState } from "preact/hooks";
import {

	Button,
	Stack,
	TextField,

} from "@mui/material";

import { parseISO } from "date-fns";
import { DatePicker } from '@mui/x-date-pickers';
import ListOfHours from "../Common/ListOfHours";

export default function AppointmentForm({ id, mode }) {
	const [state, setState] = useState({ actualDeal: undefined });
	const handleChange = (event) => {

		setState({ ...state, [event.target.name]: event.target.value });
	};

	const handleSendAppointmentInviteMail = (type) => {

		var bd = {
			dt: state.date,
			tm: state.time,

			type: type
		};

		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(bd),
		};
		fetch("/api/081b874a3c004461bb2c59cba08acc3b/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	return (
		<Stack direction="row" spacing={1}>
			{/* <DatePicker
				inputFormat="dd/MM/yyyy"
				value={state.day ? state.day : parseISO(new Date())}
				minDate={Date()}
				onChange={(date) =>
					handleChange({
						target: { name: "day", value: date.toISOString() },
					})
				}
				renderInput={(params) => <TextField size="small" placeholder="jj/mm/aaaa" style="max-width: 150px;" {...params} />}
			/> */}
			<DatePicker
				inputFormat="dd/MM/yyyy"
				disablePast
				openTo="month"
				views={['year', 'month', 'day']}
				value={state.day}
				onChange={(date) => {
					handleChange({
						target: { name: "day", value: date.toISOString() },
					})
				}}
				renderInput={(params) => <TextField size="small" placeholder="jj/mm/aaaa" style="max-width: 150px;" {...params} />}
			/>*
			<ListOfHours field_name={"time"} hour={state.time} handleChange={handleChange} />
			<Button
				variant="contained"
				onClick={() => {
					setState({ ...state, auth_signed_mod: false });
					handleSendAppointmentInviteMail(mode);
				}}
			>
				OK
			</Button>
		</Stack>
	);
};
